import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrPartnerContactAccountManager from 'client/components/SrPartnerContactAccountManager';
import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_BLUR,
} from 'client/components/SrButton/SrButton';
import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

const SrPartnerContactSupportModal = ({
  onClose,
  marketingPartnerListing,
  headline,
  headlineType,
  accountManager,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      centerContent
      showCloseButton
      closeOnBackgroundClick
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      padding={isSmallScreen
        ? 'calc(100vh - 660px) 0 0 0'
        : '0 0 120px 0'
      }
      contentPadding='0'
      onClose={onClose}
      theme={isSmallScreen ? MODAL_THEME_FIXED_FOOTER_BUTTON : null}
      buttonTheme={isSmallScreen ? SR_BUTTON_THEME_ADOBE_GREY : SR_BUTTON_THEME_BLUR}
    >
      <SrPartnerContactAccountManager
        headline={headline}
        headlineType={headlineType}
        marketingPartnerListing={marketingPartnerListing}
        accountManager={accountManager}
      />
    </SrModalV2>
  );
};

SrPartnerContactSupportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  marketingPartnerListing: PropTypes.object,
  headline: PropTypes.string,
  headlineType: PropTypes.string,
  accountManager: PropTypes.object,
};

SrPartnerContactSupportModal.displayName = 'SrPartnerContactSupportModal';

export default SrPartnerContactSupportModal;
